const ROTATION_FULL = 360;
const DEFAULT_DURATION = 400;

export function orbit_3d(node, { duration = DEFAULT_DURATION }) {
  const radius = 10;
  const scaleEffect = 0.2;
  return {
    duration,
    css: (t) => {
      const rotation = t * ROTATION_FULL;
      const scale =
        Math.cos((rotation * Math.PI) / 180) * scaleEffect + (1 - scaleEffect);
        return `
          transform-origin: center center ${-radius}px;
          transform: rotateY(${rotation}deg) scale(${scale});
          transform-style: preserve-3d;
          opacity: ${scale * 0.6 + 0.01};
          position: absolute;
          width: 100%;
          height: 100%;
        `;
    },
  };
}

export function fade_text(node, { duration = DEFAULT_DURATION }) {
  return {
    duration,
    css: (t) => {
      const rotation = t * ROTATION_FULL;
      return `
                opacity: ${rotation > 90 && rotation < 270 ? 0 : 1};
            `;
    },
  };
}
